import { orderList } from "@/apis/inventoryv2";
import { orderAdd } from "@/apis/packing";
import SelectOrderContent, { TabEnum } from "@/components/Selector/SelectOrderContent";
import SelectSaleContent from "@/components/Selector/SelectSaleContent";
import { RootState } from "@/store";
import { CommonStateEnum, SourceTypeEnum } from "@/types/common";
import { ChangeEnum, ConfirmedEnum } from "@/types/inventory";
import { OrderV2 } from "@/types/inventoryV2";
import { PackOrder, PackOrderAdd } from "@/types/packing";
import { SaleOrderItemState } from "@/types/sales";
import { Button, Flex, Form, Input, Modal, notification, Result, Spin, Steps } from "antd";
import { FC, Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

interface AddPackOrderProps {
  open: boolean;
  onSuccess: (order: PackOrder) => void;
  onClose: () => void;
}

const AddPackOrder: FC<AddPackOrderProps> = ({ open, onSuccess, onClose }) => {
  const { t } = useTranslation();
  const curOrd = useSelector((state: RootState) => state.orgReducer.curOrg);
  const [loading, setLoading] = useState<boolean>(false);
  const [saleOrders, setSaleOrders] = useState<SaleOrderItemState[]>([]);
  const [current, setCurrent] = useState<number>(0);
  const [needGetInv, setNeedGetInv] = useState<boolean>(false);
  const [inventories, setInventories] = useState<OrderV2[]>([]);
  const [outOrderIds, setOutOrderIds] = useState<string[]>([]);
  const [desc, setDesc] = useState<string>('');
  const [resPack, setResPack] = useState<PackOrder | null>(null);

  useEffect(() => {
    setNeedGetInv(true);
  }, [saleOrders])

  // const handleNext_0 = async () => {
  //   if (saleOrders.length === 0) return notification.error({ message: t('warehouse.selectSaleOrder') });
  //   if (!needGetInv) return setCurrent(1);
  //   try {
  //     setLoading(true);
  //     let orders = await orderList({ strs: saleOrders.map(o => o.id) }, curOrd.id, ConfirmedEnum.CONFIRM);
  //     let outOrders = (orders?.body || []).filter(order => order.type === ChangeEnum.PRE_OUT && order.sourceType === SourceTypeEnum.SALE)
  //     if (!!!outOrders.length) {
  //       notification.error({ message: t('warehouse.noOutOrder'), description: t('warehouse.noOutOrderTip') })
  //     } else {
  //       setInventories([...outOrders]);
  //       setNeedGetInv(false);
  //       setCurrent(1);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     notification.error({ message: t('warehouse.outOrderFail') })
  //   }
  // };

  const handleNext_1 = async () => {
    if (loading) return;
    if (outOrderIds.length === 0) return notification.error({ message: t('warehouse.selectOutOrder') });
    try {
      const addInfo: PackOrderAdd = {
        sourceOrderId: '',
        sourceOrderNumber: '',
        orgId: curOrd.id,
        shipmentOrderId: '',
        inventoryOrderIds: outOrderIds,
        remark: desc
      };
      setLoading(true);
      const res = await orderAdd(addInfo);
      notification.success({ message: t('common.addSuccess'), description: res.number });
      setResPack({ ...res });
      setCurrent(1)
    } catch (err) {
      notification.error({ message: t('common.saveFAil') });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    resPack && onSuccess(resPack);
    onClose();
  };

  const steps = [
    // {
    //   title: t('warehouse.selectSaleOrder'),
    //   key: 0,
    //   content: (
    //     <SelectSaleContent
    //       // selectType="radio"
    //       values={saleOrders.map(o => o.id)}
    //       state={CommonStateEnum.ACTIVE}
    //       onSelectOrders={setSaleOrders}
    //     />
    //   )
    // },
    {
      title: t('warehouse.selectOutOrder'),
      key: 1,
      content: (
        <Fragment>
          <Form.Item label={t('order.remark')} >
            <Input.TextArea value={desc} onChange={e => setDesc(e.target.value)} rows={2} placeholder={t('shipment.plRemark')} maxLength={1000} showCount />
          </Form.Item>
          <SelectOrderContent
            selectedIds={outOrderIds}
            selectType="checkbox"
            onSelect={setOutOrderIds}
            // initOrders={inventories}
            onlyTab={TabEnum.OUTBOUND}
            defaultConfirm={ConfirmedEnum.CONFIRM}
          />
        </Fragment>
      )
    },
    {
      title: t('common.addSuccess'),
      key: 2,
      content: (
        <Result
          status="success"
          title={t("common.addSuccess")}
          subTitle={resPack?.number ?? ''}
        />
      )
    },
  ];

  const footer = (
    <Flex justify='flex-start' gap={8} align='center'>
      {/* {current === 0 && (
        <>
          <Button type='primary' disabled={saleOrders.length === 0 || loading} onClick={handleNext_0}>{t('warehouse.next')}</Button>
        </>
      )} */}
      {current === 0 && (
        <>
          {/* <Button onClick={() => setCurrent(0)}>{t('warehouse.previous')}</Button> */}
          <Button type='primary' disabled={outOrderIds.length === 0 || loading} onClick={handleNext_1}>{t('warehouse.next')}</Button>
        </>
      )}
      {current === 1 && (
        <>
          <Button type='primary' disabled={saleOrders.length === 0 || loading} onClick={() => onSuccess(resPack!)}>{t('warehouse.complete')}</Button>
        </>
      )}
    </Flex>
  );

  return (
    <Modal title={t('warehouse.addPack')}
      width={1200} open={open}
      centered footer={footer} onCancel={handleClose}
      maskClosable={false}
    >
      <Spin spinning={loading}>
        <Flex vertical style={{ height: "70vh" }} gap={6}>
          <Steps current={current} items={steps} />
          {steps[current].content}
        </Flex>
      </Spin>
    </Modal>
  )
};

export default AddPackOrder;
